import { render, staticRenderFns } from "./IotDeviceStatus.vue?vue&type=template&id=66b4236b&scoped=true"
import script from "./IotDeviceStatus.vue?vue&type=script&lang=ts"
export * from "./IotDeviceStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4236b",
  null
  
)

export default component.exports